import React, { useEffect, useState } from "react";
import QRCode from "qrcode.react";
import { Modal, Spin } from "antd";
import firebase from "firebase";

export const CreativeQrCode: React.FC<{ childPath?: string, onCancel?: () => void }> = ({ childPath, onCancel }) => {
    const [url, setUrl] = useState();

    useEffect(() => {
        if (childPath) {
            setUrl(undefined);
            const targetPath = childPath;
            firebase.storage().ref(targetPath).getDownloadURL().then((res) => {
                if (targetPath === childPath) {
                    setUrl(res);
                }
            });
        }
    }, [childPath]);

    return (
        <Modal
            visible={childPath !== undefined}
            onCancel={() => {
                onCancel?.();
            }}
            destroyOnClose={true}
            footer={false}>
            <div style={{
                width: '100%',
                height: '340px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                {url === undefined ? <Spin spinning={true} /> : <QRCode size={300} value={url} />}
            </div>
        </Modal>
    );
}